<template>
  <div class="authentication">
    <div class="background" :style="background"></div>
    <fp-loader v-if="$store.getters.ORGANIZATION_LOADING" />
    <div v-else class="content">
      <logout v-if="logout" :logout-done="logoutDone" />
      <organization-login v-else-if="$store.getters.NEED_ORGANIZATION_LOGIN && $store.getters.SESSION" />
      <div v-else-if="!$store.getters.SESSION">
        <password-renew v-if="needRenew" />
        <login-all-in-one v-else-if="allInOne" />
        <login-selector
          v-else-if="!mode"
          @select="(value) => mode = value"
        />
        <login
          v-else-if="mode"
          @close="mode = null"
          :mode="mode"
        />
      </div>
      <mfa v-else-if="needMfa" @logout-done="logoutDone = true" />
    </div>
    <!-- NOTE: the App roots render this screen instead of the router view, so RouteWrapper
         (which carries the button everywhere else) is not mounted here -->
    <fp-consent-button />
  </div>
</template>

<script>
import Login from './Login'
import OrganizationLogin from './OrganizationLogin'
import Logout from './Logout.vue'
import LoginSelector from './LoginSelector.vue'
import LoginAllInOne from './LoginAllInOne.vue'
import Mfa from './MFA'

import backgroundTexture from '@/shared/assets/img/login_background.svg'
const PasswordRenew = () => import('./PasswordRenew.vue')

export default {
  components: { LoginAllInOne, LoginSelector, Login, PasswordRenew, Logout, Mfa, OrganizationLogin },
  props: {
    organizationId: { type: String, default: () => null }
  },
  data () {
    return {
      mode: null,
      logoutDone: false
    }
  },
  computed: {
    allInOne () {
      if (this.authModes?.length > 1) return true
      // A lone login_password mode must still use the all-in-one screen when the
      // org allows self-service: LoginSelector -> Login has no signup entry, so
      // signup (further gated by the SIGNUP flag inside LoginAllInOne) would be
      // unreachable otherwise. See signup-access.spec.js.
      return this.authModes?.length === 1 &&
        this.authModes[0].type === 'login_password' &&
        this.selfService
    },
    selfService () {
      return this.$store.getters.PREFERENCES?.self_service || false
    },
    authModes () {
      return this.$store.getters.PREFERENCES?.auth_mode.filter(authMode => {
        return authMode.visible && !authMode.hidden
      })
    },
    needRenew () {
      return this.$route.query.reset_password
    },
    needMfa () {
      if (!this.$store.getters.SESSION) return false
      return this.$store.getters.SESSION.acr === 'aal1'
    },
    logout () {
      return typeof (this.$route.query.logout) !== 'undefined'
    },
    background () {
      return {
        background: `url(${backgroundTexture}) no-repeat, linear-gradient(180deg, #035599 0%, #00B8E0 54.17%, #035599 100%) no-repeat, radial-gradient(59.98% 30.76% at 29.67% 50%, rgba(255, 255, 255, 0.00) 0%, rgba(217, 217, 217, 0.22) 100%)`,
        'background-size': 'cover'
      }
    }
  }
}
</script>

<style lang="less">
  .authentication {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    > .background {
      position: fixed;
      width: 100vw;
      height: 100vh;
      bottom: 0;
      z-index: 0;
    }
    .content {
      z-index: 1;
      border-radius: 10px;
      border: 0.5px solid #E4E7EC;
      background: #FFF;
      box-shadow: 0px 2px 4px 0px rgba(52, 65, 78, 0.05);
      width: 558px;
      padding: 24px;
      margin: 20px 0;
      h1 {
        color: @text-color;
        font-size: 38px;
        font-weight: 600;
        margin-top: 10px;
      }
    }
    .logo {
      width: 150px;
    }
  }
</style>
